import React from "react";
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
// New page Added


const ProductsVCIMFr = (props) => {
  return (
    <>
    <Header en="/products/visitors-canada-insurance/monthly" fr="/produits/assurance-visiteurs-au-canada-frair-medicaux-durgence/mensuel" lang="fr" />
    <div className="container mainDiv ab">
      <div className="row">
        <div className="col-xs-12 content">
          <h1 className="visitors-canada-insurance-monthly">Plan de paiement mensuel de l'assurance Super Visa</h1>
          <div>
            <div className="bannerInner header_visitors-canada-insurance-monthly"></div>
            <div className="row">
              <div className="col-lg-12">
                <p>L’ <strong>option de paiement mensuel</strong> offre un moyen pratique de payer la prime pour <a href="/produits/assurance-visiteurs-au-canada-frair-medicaux-durgence">l’assurance médicale d’urgence des visiteurs au Canada</a> .</p>
              </div>
              <div className="col-lg-12">
                <p><strong>Exigences:</strong>
                <ul>
                  <li>Disponible pour les plans avec 90 jours de voyage ou plus</li>
                  <li>Prime de deux mois perçue à la date de candidature</li>
                  <li>Des paiements mensuels égaux sont appliqués à la carte de crédit à partir de la date de début de la police</li>
                  <li>Remboursements quotidiens au prorata disponibles pour les annulations (des frais d’administration s’appliquent)</li>
                  <li>60 $ de frais de facturation non remboursables</li>
                </ul>
                </p>
              </div>
              <div className="col-lg-12">
                <p><a href="/contact-us/">Contactez-nous</a> ou votre courtier partenaire Travelance pour en savoir plus !</p>
                <p>L’assurance médicale d’urgence souscrite aux fins du super visa pour parents et grands-parents doit répondre aux <a href="https://www.canada.ca/en/immigration-refugees-citizenship/corporate/publications-manuals/operational-bulletins-manuals/temporary-residents/visitors/super-visa.html">exigences de l’IRCC.</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer lang="fr" />
    </>
  );
}

export default ProductsVCIMFr;
